/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs/operators';

@Component({
  selector: 'wsn-external-link',
  templateUrl: './external-link.component.html',
  styleUrls: ['./external-link.component.scss']
})
export class ExternalLinkComponent implements OnInit {
  url: string;

  constructor(private router: Router, route: ActivatedRoute) {
    route.data.pipe(map((d) => d['url'])).subscribe((url) => {
      this.url = url;
    });
  }

  ngOnInit(): void {
    // Open new browser tab
    window.open(this.url);
    // Return this tab to the default route
    this.router.navigate(['']);
  }
}
